import React, { FC, PropsWithChildren } from 'react'
import { useCheckoutSizes } from '../../utils/responsive'
import { Grid, Heading, Text, useThemePerClass } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useAppRouter, useCheckoutState, useMerchantAvatarUrlWithFallback, useMerchantDisplayNameOrName } from '../../state'
import { ImageWithFallback } from '../ImageWithFallback'
import { Money } from '../Money'
import { useTranslation } from '../../utils/convergence'
import { MerchantAvatarFallback } from '../MerchantAvatarFallback'

const GridItem = Grid.Item
const GridFixedItem = Grid.FixedItem

export const GiftCardHeader: FC<PropsWithChildren> = () => {
  const { t } = useTranslation(['financeFee'])
  const { locale } = useAppRouter()
  const { started } = useCheckoutState()
  const { sectionHeadingSize } = useCheckoutSizes()
  const themeClass = useThemePerClass(styles)
  const merchantDisplayNameOrName = useMerchantDisplayNameOrName()
  const giftCardAmount = started?.consumerAmount
  const avatarUrl = useMerchantAvatarUrlWithFallback()

  return (
    <>
      <div className={themeClass.container}>
        <div className={themeClass.iconContainer}>
          {avatarUrl.length > 0 ? (
            <ImageWithFallback
              data-testid='experiment-merchant-logo'
              alt='merchant-logo'
              src={avatarUrl}
              width={64}
              height={64}
              className={styles.merchantLogo}
              fallback={<MerchantAvatarFallback placeholderText={merchantDisplayNameOrName} />}
            />
          ) : (
            <MerchantAvatarFallback placeholderText={merchantDisplayNameOrName} />
          )}
        </div>
        <Heading size='L' testNameSpace='merchant-name-header'>
          {merchantDisplayNameOrName}
        </Heading>
        <div className={themeClass.content}>
          <Grid justifyContent='space-between'>
            <GridItem>
              <Text renderAs='span' color='Standard' size={sectionHeadingSize}>
                {t('summary.giftCard.subTitle')}
              </Text>
            </GridItem>
            <GridFixedItem align='right'>
              <Money locale={locale} color='Standard' size={sectionHeadingSize} value={giftCardAmount} />
            </GridFixedItem>
          </Grid>
        </div>
      </div>
    </>
  )
}
